import _ from 'lodash';
import { createSelector } from 'reselect';

import { getSavedSearchResultsKey } from '../../reducers/SavedSearchResultsReducer';
import { SUPPORTED_SAVED_SEARCH_ACTIONS } from '../constants/editor.constants';

const getSavedSearches = (state) => state.savedSearchDesigner?.savedSearches || [];

export const getEntityTreeFields = (state) => state.savedSearchDesigner?.entityTreeFields ?? [];
export const getComponentProps = (_, props) => props || {};
export const getSavedSearch = (state, props) =>
  state.savedSearchDesigner?.savedSearches?.[props.selectedSavedSearchId]?.savedSearch ?? {};
export const getSelectedSavedSearchId = (state) =>
  state.savedSearchDesigner?.selectedSavedSearchId ?? '';
export const getSavedSearchName = (state, props) =>
  state.savedSearchDesigner?.savedSearches?.[props.selectedSavedSearchId]?.savedSearch
    ?.searchName ?? '';
export const getValidationErrors = (state) => state.savedSearchDesigner?.validationErrors ?? [];
export const getSelectedTableRow = (state) => state.savedSearchDesigner?.selectedTableRow?.rowId;
export const getIsDocRepository = (state) => state.savedSearchDesigner.isDocRepository ?? false;
export const getSavedSearchResults = (state) => state.savedSearchResults;

export const getSavedSearchProp = createSelector(
  [getSavedSearch, getComponentProps],
  (savedSearch, { prop }) => _.get(savedSearch, prop, null)
);

export const getSavedSearchActions = createSelector([getSavedSearch], (savedSearch) =>
  savedSearch.actions.filter(
    (action) =>
      !action.actionTemplate || SUPPORTED_SAVED_SEARCH_ACTIONS.includes(action.actionTemplate)
  )
);

export const getSavedSearchTableRows = createSelector(
  [getSavedSearch, getValidationErrors, getComponentProps],
  (savedSearch, validationErrors, { tablePath }) => {
    const tableRows = _.get(savedSearch, tablePath, []);

    return tableRows.map((item) => ({
      ...item,
      errors: validationErrors.filter((error) => error.instanceId === item.rowId),
    }));
  }
);

export const hasSavedSearchUnsavedChanges = createSelector([getSavedSearches], (savedSearches) =>
  Object.values(savedSearches).some(
    ({ savedSearch, originalSavedSearch }) => !_.isEqual(savedSearch, originalSavedSearch)
  )
);

export const getErrorByProp = createSelector(
  [getValidationErrors, getComponentProps],
  (validationErrors, { prop }) => {
    return validationErrors.find((error) => error?.controlInfo?.prop === prop);
  }
);

export const getSavedSearchTitle = createSelector(
  [getSavedSearchResults, getComponentProps],
  (savedSearchResults, { entityName, savedSearchName, defaultTitle }) => {
    const savedSearchId = getSavedSearchResultsKey(entityName, savedSearchName);
    const savedSearch = savedSearchResults[savedSearchId];
    return (
      savedSearch?.results?.translatedSearchName ||
      savedSearch?.results?.translatedEntityName ||
      savedSearchName ||
      defaultTitle
    );
  }
);

export const getEntityTreeFieldsWithFilter = createSelector(
  [getEntityTreeFields, getComponentProps],
  (entityTreeFields, { onlyRootEntityFields = false }) =>
    onlyRootEntityFields
      ? [
          {
            ...entityTreeFields[0],
            childrenNodes:
              entityTreeFields[0]?.childrenNodes?.filter(
                ({ value, isSelectable }) => !value && !isSelectable
              ) || [],
          },
        ]
      : entityTreeFields
);
